import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ShippingPackReferenceService extends BaseReferenceService {
  constructor() {
    super('ShippingPackReference');
  }

  getForShipper(supplierId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForSupplier/${supplierId}`);
  }
}
